import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ContractDistributionsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/contract_distributions", { params: toSnakeCase(params) });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/contract_distributions/${id}`, { params: { includes } });
  }

  orderKit(id, storeId) {
    return securedAxiosInstance.post(`/contract_distributions/${id}/order_kit`, toSnakeCase({ storeId }));
  }
}

export default new ContractDistributionsService();
